// O que pode ENTRAR em progresso de reprodução persistido (posição/duração).
//
// ── O defeito que isto fecha ──
// Os players filtravam `Infinity` na EXIBIÇÃO (`v.duration !== Infinity`) mas
// gravavam com o guard `v.duration > 0` — que é `true` pra `Infinity`. Stream sem
// fim declarado (HLS sem ENDLIST, TS) gravava `durationSec: Infinity`; em
// `local-db`, `ratio = positionSec / Infinity = 0` e o episódio NUNCA virava
// `finished`, por mais que se assistisse: ficava "em andamento" pra sempre, com o
// retomar apontando pro fim. No fallback em localStorage (JSON) o `Infinity` ainda
// vira `null`. Os guards `v.duration === 0` (intervalo de VOD e catch-up) deixavam
// passar `Infinity` E `NaN`.
//
// ── A regra ──
// Duração persistível = FINITA e POSITIVA. Sem duração conhecida não há razão
// posição/duração honesta — então não se grava. O episódio continua virando
// `finished` pelos caminhos explícitos (`ended`, auto-advance, "Já vi"), que não
// dependem da razão. Custo aceito: stream com duração desconhecida não ganha ponto
// de retomada (o seek nele já não era confiável).

/** Duração que pode ir pro progresso persistido: finita e > 0 (exclui NaN, ±Infinity, 0, negativos). */
export function isPersistableDuration(durationSec: number): boolean {
  return Number.isFinite(durationSec) && durationSec > 0
}

/** Par posição/duração persistível. Posição finita e ≥ 0; duração conforme acima. */
export function isPersistableProgress(positionSec: number, durationSec: number): boolean {
  return Number.isFinite(positionSec) && positionSec >= 0 && isPersistableDuration(durationSec)
}
